<div class="main">
  <div class="mainSection">
    <div class="header">
      <div class="title">
        <div class="label" (click)="changeOrder('active')" [ngClass]="{ active: selectedOrderStatus == 'active' }"
          *ngIf="!selectedStatus.is_deleted && !urlParams.mode" style="cursor: pointer;line-height  : 35px;">
          {{'ORDER_DASHBOARD.myorders' | translate}}
        </div>
        <div class="label" style="margin-left: 20px;cursor: pointer;line-height  : 35px;"
          [ngClass]="{ active: selectedOrderStatus == 'flash' }" (click)="changeOrder('flash')"
          *ngIf="!selectedStatus.is_deleted && !urlParams.mode">
          {{'ORDER_DASHBOARD.flash_orders' | translate}}
        </div>
        <div class="label" style="margin-left: 20px;cursor: pointer;line-height  : 35px;"
          [ngClass]="{ active: selectedOrder == 'ltl' }" (click)="changeOrder('ltl')"
          *ngIf="!selectedStatus.is_deleted">
          {{'LTL' | translate}}
        </div>

        <div class="label" *ngIf="selectedStatus.is_deleted && !urlParams.mode">
          {{'ORDER_DASHBOARD.myorders_deleted' | translate}}
        </div>
        <div class="label" *ngIf="urlParams.mode && urlParams.type=='acceptance'">
          {{'OVERVIEW_DASHBOARD.pending_acceptance' | translate}}
        </div>
        <div class="label" *ngIf="urlParams.mode && urlParams.type=='assignment'">
          {{'OVERVIEW_DASHBOARD.pending_assignment' | translate}}
        </div>
        <!-- <div class="help" [hidden]="selectedStatus.is_deleted" (click)="openUploadDocs()">
          <app-help [helpData]="helpDataActive"></app-help>
        </div>
        <div class="help" *ngIf="selectedStatus.is_deleted">
          <app-help [helpData]="helpDataDeleted"></app-help>
        </div> -->
      </div>
      <div class="status">
        <span>
          {{'ORDER_DASHBOARD.status' | translate}}:
        </span>

      </div>
      <div class="dropdown">
        <mat-select class="inputSelect" [(value)]="selectedStatus" style="color: #fff;">
          <mat-option *ngFor="let status of statusArray" [value]="status" (click)="selectStatus(status)">
            {{status.status}}
          </mat-option>
        </mat-select>
      </div>
      <div class="refresh" (click)="paginator.pageIndex = 0;getOrders()"><i class="material-icons">refresh</i></div>
    </div>
    <div class="orders">
      <div class="orderSwitch">
      </div>
      <div class="load">
        <mat-paginator #paginatorTop (page)="handlePageTop($event)" showFirstLastButtons
        [length]="(ordersList)? totalCount:0" [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="25"
        style="padding-bottom: 0px; "></mat-paginator>

        <table mat-table *ngIf="ordersList && ordersList.filteredData.length;else noOrders" [dataSource]="ordersList"
          matSort (matSortChange)="sortOrderData($event)" class="orderTable">

          <ng-container matColumnDef="order">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
              <!-- Order  -->
              <input type="text" [placeholder]="'ORDER_DASHBOARD.order' | translate" title="Order"
                [(ngModel)]="filterOrder" (keyup)="searchFilter(filterOrder, 'order')"
                (click)="$event.stopPropagation()" class="formField" />

            </th>
            <td mat-cell *matCellDef="let element" class="orderStyle" >
              <div style="display: flex; flex-direction: row;margin-top: 10px;">
                <div style="margin:0px 0px 0px 5px">
                  <a *ngIf="element.tracker" target="_blank" href="{{element.tracker}}">{{element.order}}</a>
                  <span *ngIf="!element.tracker">{{element.order}}</span>
                </div>
                <div>
                  <img *ngIf="element.comments" matTooltipClass="comments-tooltip" src="assets/Comment.svg" alt=""
                    height="18px" matTooltip="{{element.comments}}" matTooltipPosition="after">
                </div>
              </div>
              <div  class="do_numbers_available" *ngIf="element.sale_order">
                <div *ngIf="element.sale_order" style="display: flex;align-items: center;gap: 8px;">
                  <div *ngFor="let saleOrder of element.sale_order.split(','); let i = index" >
                    <div *ngIf="i < 1">
                      {{ saleOrder }}
                    </div>
                    <div class="buble_round" *ngIf="i === 1 && element.sale_order.split(',').length > 1" matTooltipClass="comments-tooltip" matTooltip="{{ element.sale_order.split(',').slice(1).join(',') }}">
                      +{{ element.sale_order.split(',').length - 1 }}
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>

          <!-- <ng-container matColumnDef="organization">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
              Organization
              <input type="text" placeholder="Organization" title="Organization" (click)="$event.stopPropagation()" class="formField" />
            </th>
            <td mat-cell *matCellDef="let element"> {{element.organization.name}} </td>
          </ng-container> -->

          <ng-container matColumnDef="shipper">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
              <!-- Shipper -->
              <input type="text" [placeholder]="'ORDER_DASHBOARD.shipper' | translate" [(ngModel)]="filterShipper"
                title="Shipper" (keyup)="searchFilter(filterShipper, 'shipper')" (click)="$event.stopPropagation()"
                class="formField" />
            </th>
            <td mat-cell *matCellDef="let element"> <span style="font-weight: bold;">{{element.shipper.parent_name}} -
              </span>{{element.shipper.name}} </td>
          </ng-container>

          <ng-container matColumnDef="from">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
              <div style="text-align: center;width: 100%;">

                {{'ORDER_DASHBOARD.from' | translate}}
              </div>
              <!-- <input type="text" placeholder="From" title="From" (click)="$event.stopPropagation()" class="formField" /> -->
            </th>
            <td mat-cell *matCellDef="let element">
              <span *ngFor="let pick of element.from; let i=index; let onlyFirst = first">
                <strong style="color: #0B7D2E;">P{{i+1}}</strong> - {{pick.loc_id.name}} {{pick.loc_id.city}}<br>
                <div *ngIf="onlyFirst" style="font-size: 10px; color: #757575;">Pickup Date : {{element.pickDate}}</div>
                <span *ngIf="(element.length > 1) && (i != element.length-1)">,</span>
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="to">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
              <div style="text-align: center;width: 100%;">
                {{'ORDER_DASHBOARD.to' | translate}}
              </div>
              <!-- <input type="text" placeholder="To" title="To" (click)="$event.stopPropagation()" class="formField" /> -->
            </th>
            <td mat-cell *matCellDef="let element">
              <span *ngFor="let delivery of element.to; let i=index">
                <b style="color: #D8511F;">D{{i+1}}</b> - {{delivery.loc_id.name}} - {{delivery.loc_id.city}}<br>
                <span *ngIf="(element.length > 1) && (i != element.length-1)">,</span>
              </span>
            </td>
          </ng-container>


          <ng-container matColumnDef="vehicle">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="customHeader">
              <div style="text-align: center;width: 100%;">

                {{'ORDER_DASHBOARD.vehType' | translate}}
              </div>
              <!-- <input type="text" placeholder="Vehicle" title="Vehicle" (click)="$event.stopPropagation()" class="formField" /> -->
            </th>
            <td mat-cell *matCellDef="let element">
              <div *ngIf="element.vehicle.name">
                {{element.vehicle.name}}
              </div>
              <div *ngIf="!element.vehicle.name">
                {{element.vehicle}}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="freight">
            <th mat-header-cell *matHeaderCellDef class="customHeader">
              <!-- {{'ORDER_DASHBOARD.toBeAccepted' | translate}} -->
              {{'ORDER_DASHBOARD.freight' | translate}}
            </th>
            <td mat-cell *matCellDef="let element">
              {{element.freight}}
            </td>
          </ng-container>
          
          <ng-container matColumnDef="requested">
            <th mat-header-cell *matHeaderCellDef class="customHeader">
              <!-- {{'ORDER_DASHBOARD.toBeAccepted' | translate}} -->
              {{(selectedOrderStatus === 'active') ?
              ('ORDER_DASHBOARD.toBeAccepted' | translate) : ('ORDER_DASHBOARD.no_vehicles' |
              translate) }}
              <br>
              ({{'ORDER_DASHBOARD.vehicleUom' | translate}})
            </th>
            <td mat-cell *matCellDef="let element">

              {{(selectedOrderStatus === 'active') ?
              element.to_be_accepted : element.requested}}
            </td>
          </ng-container>

          <ng-container matColumnDef="price">
            <th mat-header-cell *matHeaderCellDef class="customHeader">
              {{'Price' | translate}}
            </th>
            <td mat-cell *matCellDef="let element"> {{element.rate}} </td>
          </ng-container>

          <ng-container matColumnDef="accepted">
            <th mat-header-cell *matHeaderCellDef class="customHeader">
              {{'ORDER_DASHBOARD.toBeAssigned' | translate}}
              <br>
              ({{'ORDER_DASHBOARD.vehicleUom' | translate}})
            </th>
            <td mat-cell *matCellDef="let element"> {{element.to_be_assigned}} </td>
          </ng-container>

          <ng-container matColumnDef="reason">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'ORDER_DASHBOARD.reason' | translate}}</th>
            <td mat-cell *matCellDef="let element" style="
            max-width: 100px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;" title="{{element.delete_reason}}"> {{element.delete_reason}} </td>
          </ng-container>

          <!-- <ng-container matColumnDef="costPerVehicle">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'ORDER_DASHBOARD.rate' | translate}} ({{currencySymbol}}) </th>
            <td mat-cell *matCellDef="let element">{{element.costPerVehicle}} </td>
          </ng-container> -->

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="customHeader"> {{'ORDER_DASHBOARD.actions' | translate}} </th>
            <td mat-cell *matCellDef="let element">
              <div class="buttons">
                <!-- <div class="button" (click)="$event.stopPropagation();showOrderDetails(element);" >{{'ORDER_DASHBOARD.view' | translate}}</div> -->

                <div class="button" style="background-color: #3c7715" *ngIf="selectedOrderStatus=='active'"
                  (click)="$event.stopPropagation();openOrderDetails(element);">
                  {{'ORDER_DASHBOARD.open' | translate}}</div>

                <div class="button" *ngIf="selectedOrderStatus=='flash'"
                  (click)="$event.stopPropagation(); parellAccept(element)">Accept</div>
              </div>
            </td>
          </ng-container>

          <!-- Header row second group -->

          <!-- <ng-container matColumnDef="span-order">
            <th mat-header-cell class="customHeader" *matHeaderCellDef [attr.colspan]="1">  </th>
          </ng-container>

          <ng-container matColumnDef="span-shipper">
            <th mat-header-cell class="customHeader" *matHeaderCellDef [attr.colspan]="1">  </th>
          </ng-container>

          <ng-container matColumnDef="span-from">
            <th mat-header-cell class="customHeader" *matHeaderCellDef [attr.colspan]="1">  </th>
          </ng-container>

          <ng-container matColumnDef="span-to">
            <th mat-header-cell class="customHeader" *matHeaderCellDef [attr.colspan]="1">  </th>
          </ng-container>

          <ng-container matColumnDef="span-vehicleType">
            <th mat-header-cell class="customHeader" *matHeaderCellDef [attr.colspan]="1"> </th>
          </ng-container>

          <ng-container matColumnDef="span-vehicle">
            <th mat-header-cell class="customHeader" *matHeaderCellDef [attr.colspan]="2"> Vehicle </th>
          </ng-container>

          <ng-container matColumnDef="span-costPerVehicle">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="1" class="border customHeader"></th>
          </ng-container>

          <ng-container matColumnDef="span-status">
            <th mat-header-cell *matHeaderCellDef [attr.colspan]="2" class="border customHeader"></th>
          </ng-container>

          <tr mat-header-row
            *matHeaderRowDef="['span-order', 'span-shipper', 'span-from', 'span-to', 'span-vehicleType', 'span-vehicle', 'span-costPerVehicle', 'span-status']">
          </tr> -->

          <tr mat-header-row *matHeaderRowDef="ordersDisplay; sticky: true;" style="font-weight: bold !important;"></tr>
          <tr mat-row (click)="tabIndex = 0;(selectedOrderStatus=='active') ? (openAssignSideModal(row)) : '';"
            [ngClass]="{'highlightRows': selectedStatus.is_deleted == true,'highlightRow': (selectedOrderData)?row._id == selectedOrderData._id:false}"
            *matRowDef="let row; columns: ordersDisplay;" style="height: 65px; font-weight: bold;"></tr>
        </table>

          <mat-paginator #paginatorBottom (page)="handlePageBottom($event)" showFirstLastButtons
        [length]="(ordersList)? totalCount:0" [pageSizeOptions]="[5, 10, 25, 100]" [pageSize]="25">
      </mat-paginator>



      </div>



      <div class="semiTransparentBackground" [hidden]="!showStatusTab" [@fadeIn]></div>

      <div class="statusTab" *ngIf="showStatusTab" [@slideInOut]>
        <i class="material-icons" (click)="showStatusTab=0; selectedOrderData={}; tab=0;changeTab()">clear</i>
        <div class="orderView" *ngIf="showOrderDetailsView==1">
          <div class="header">
            {{'ORDER_DASHBOARD.view' | translate}} Order
          </div>
          <div class="section">
            <div class="order-placed">{{'ORDER_DASHBOARD.order_placed' | translate}}
              {{timeService.toShortDateTime(selectedOrderData.created_at)}}</div>
            <div class="stepper">
              <mat-vertical-stepper [selected]="selectedOrderAllLocationsData.length + 10" [linear]="true" #stepper>
                <mat-step [label]="locStep._id" [state]="locStep._id"
                  *ngFor="let locStep of selectedOrderAllLocationsData;let i = index">
                  <ng-template matStepLabel>{{locStep.loc_id.name}}</ng-template>
                  <div class="areaDetails">
                    {{locStep.loc_id.area}} <br>

                    <span class="dateTime">
                      <i class="material-icons"
                        style="color: #666;margin-right: 6px;margin-top: -5px;margin-left: -2px;">date_range</i>
                      {{changeDateFormat(locStep.date_time)}}
                    </span>
                  </div>
                </mat-step>
                <ng-template *ngFor="let locStep of selectedOrderData.from;let i = index"
                  [matStepperIcon]="locStep._id">
                  <span class="pickStep" style="font-size: 14px;">P{{i+1}}</span>
                </ng-template>
                <ng-template *ngFor="let locStep of selectedOrderData.to;let i = index" [matStepperIcon]="locStep._id">
                  <span class="dropStep" style="font-size: 14px;">D{{i+1}}</span>
                </ng-template>

              </mat-vertical-stepper>
            </div>


            <div class="documentSection" *ngIf="selectedOrderData.docs.length; else noDocs">
              <div class="documents" *ngFor="let item of selectedOrderData.docs">
                <a href="{{item.link}}" class="icon">
                  <img
                    *ngIf="item.extension == 'png' || item.extension == 'jpg' || item.extension == 'jpeg || item.extension == 'gif"
                    class="image" src="assets/image-icon.svg">
                  <img *ngIf="item.extension == 'pdf'" class="image" src="assets/PDF-icon.svg">
                  <img
                    *ngIf="item.extension == 'doc' || item.extension == 'csv' || item.extension == 'docx' || item.extension == 'txt' || item.extension == 'xlsx'"
                    class="image" src="assets/Doc-icon.svg">
                </a>
              </div>
            </div>

            <ng-template #noDocs>
              <div class="noDocs">
                {{'ORDER_DASHBOARD.noDocs' | translate}}
              </div>
            </ng-template>

            <div class="accessoriesSection" *ngIf="selectedOrderData.accessories.length; else noAccessories">
              <div class="heading">
                {{'ORDER_DASHBOARD.accessories' | translate}} :
              </div>
              <span class="data" *ngFor="let item of selectedOrderData.accessories; let ind = index;">
                {{item.name}}
                <span
                  *ngIf="selectedOrderData.accessories.length > 1 && ind != selectedOrderData.accessories.length-1">,
                </span>
              </span>
            </div>

            <ng-template #noAccessories>
              <div class="noDocs">
                {{'ORDER_DASHBOARD.noAccessories' | translate}}
              </div>
            </ng-template>

          </div>
        </div>
        <div class="assignDetails" *ngIf="showOrderDetailsView==0">
          <div class="statusHeader">
            <mat-grid-list cols="2" rowHeight="3:1">
              <mat-grid-tile [ngClass]="{'selected' : tabIndex==0}" (click)="tabIndex = 0;">
                <span>{{'ORDER_DASHBOARD.allocStatus' | translate}}</span>
              </mat-grid-tile>
              <mat-grid-tile [ngClass]="{'selected' : tabIndex==1}" (click)="tabIndex = 1; getShipmentStatus();">
                <span>{{'ORDER_DASHBOARD.shipStatus' | translate}}</span>
              </mat-grid-tile>
            </mat-grid-list>
          </div>
          <div class="allocationData" *ngIf="tabIndex == 0">
            <div class="statusBody">
              <div class="allocTable">
                <div class="table" *ngIf='allocationDataSource.length'>


                  <div class="accordions">
                    <mat-accordion style="font-family: 'Muli', sans-serif;">
                      <mat-expansion-panel [expanded]="i==0" *ngFor="let item of allocationDataSource; let i =index;">
                        <mat-expansion-panel-header>
                          <mat-panel-title>
                            {{'ORDER_DASHBOARD.allocatedOn' | translate}} - {{item.created_at}}
                          </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div class="allocation">
                          <table mat-table #allocTable class="allocationTable" [dataSource]="item.allocationArray">

                            <ng-container matColumnDef="slno">
                              <th mat-header-cell *matHeaderCellDef class="allocationHeader">
                                <div style="position: relative;top: 10px;">
                                  {{'ORDER_DASHBOARD.siNo' |
                                  translate}}
                                </div>
                              </th>
                              <td mat-cell *matCellDef="let element"> {{element.slno}} </td>
                            </ng-container>

                            <ng-container matColumnDef="requested">
                              <th mat-header-cell *matHeaderCellDef class="allocationHeader">
                                <div class="allocation-icon">
                                  <img style="width: 18px;position: relative" src="assets/Request.svg" alt="">
                                </div>

                                <div class="allocation-icon">{{'ORDER_DASHBOARD.requested' | translate}}</div>
                              </th>
                              <td mat-cell *matCellDef="let element"> {{element.allocated}} <span><img
                                    src="assets/helpicon.svg" alt="" class="offered_price"
                                    title="Offered Price : {{currencySymbol}} {{element.offered_price}}"></span> </td>
                            </ng-container>

                            <ng-container matColumnDef="accepted">
                              <th mat-header-cell *matHeaderCellDef class="allocationHeader">
                                <div class="allocation-icon">
                                  <img style="width: 18px;position: relative" src="assets/Accepted.svg" alt="">
                                </div>
                                <div class="allocation-icon">{{'ORDER_DASHBOARD.accepted' | translate}}</div>
                              </th>
                              <td mat-cell *matCellDef="let element"> {{element.accepted}} </td>
                            </ng-container>

                            <ng-container matColumnDef="assigned">
                              <th mat-header-cell *matHeaderCellDef class="allocationHeader">
                                <div class="allocation-icon">
                                  <img style="width: 18px;position: relative" src="assets/Assign.svg" alt="">
                                </div>
                                <div class="allocation-icon">{{'ORDER_DASHBOARD.assigned' | translate}}</div>
                              </th>
                              <td mat-cell *matCellDef="let element"> {{element.assigned}} </td>
                            </ng-container>

                            <ng-container matColumnDef="cancelled">
                              <th mat-header-cell *matHeaderCellDef class="allocationHeader">
                                <div class="allocation-icon"><img style="width: 18px;position: relative"
                                    src="assets/Cancelled.svg" alt=""></div>
                                <div class="allocation-icon">{{'ORDER_DASHBOARD.cancelled' | translate}}</div>
                              </th>
                              <td mat-cell *matCellDef="let element"> {{element.cancelled}} </td>
                            </ng-container>

                            <ng-container matColumnDef="deadline">
                              <th mat-header-cell *matHeaderCellDef class="allocationHeader">
                                <div class="allocation-icon">
                                  <img style="width: 18px;position: relative" src="assets/Deadline.svg" alt="">
                                </div>
                                <div class="allocation-icon">{{'ORDER_DASHBOARD.deadline' | translate}}</div>
                              </th>
                              <!-- <td mat-cell *matCellDef="let element">
                            {{element.deadline}}
                          </td> -->
                              <td mat-cell *matCellDef="let element"
                                [ngStyle]="{'color':element.disableAssign || element.disableAccept ? '#000':'#e54031'}">
                                <span *ngIf=" element.accepted != 0 && element.assignmentDeadline"
                                  style="font-size: 10px;"
                                  [ngStyle]="{'color':element.disableAssign ? '#000':'#e54031'}">{{'ORDER_DASHBOARD.assignBefore'
                                  | translate}}</span>
                                <span *ngIf="element.accepted == 0 && element.acceptanceDeadline"
                                  style="font-size: 10px;"
                                  [ngStyle]="{'color':element.disableAccept ? '#000':'#e54031'}">{{'ORDER_DASHBOARD.acceptBefore'
                                  | translate}}</span><br>
                                {{ (element.accepted != 0) ? element.assignmentDeadline : element.acceptanceDeadline}}
                              </td>
                            </ng-container>
                            <!-- Symbol Column -->
                            <ng-container matColumnDef="action">
                              <th mat-header-cell *matHeaderCellDef class="allocationHeader">
                                <div style="position: relative;top: 10px;">{{'ORDER_DASHBOARD.action'
                                  | translate}}</div>
                              </th>
                              <td mat-cell *matCellDef="let element">
                                <mat-icon class="more-icon" [matMenuTriggerFor]="actions"
                                  (click)="$event.stopPropagation()" style="cursor:pointer">
                                  more_vert</mat-icon>
                                <mat-menu #actions="matMenu">
                                  <button [disabled]="!element.disableAccept" mat-menu-item
                                    *ngIf='element.accepted == 0'
                                    (click)="(element.disableAccept)? openAcceptModal(element) : '';">
                                    {{'ORDER_DASHBOARD.accept' | translate}}</button>
                                  <button mat-menu-item [disabled]="!element.disableAssign" mat-menu-item
                                    *ngIf='element.accepted != 0'
                                    (click)="(element.disableAssign && ( element.assign_number > 0) ) ? openAssignModal(element) : '';">
                                    {{'ORDER_DASHBOARD.assign' | translate}}</button>
                                  <button mat-menu-item (click)="openChatBox(element)">{{'ORDER_DASHBOARD.chat' |
                                    translate}}</button>
                                </mat-menu>
                                <div class="rejected" *ngIf="element.disable_btns">
                                  <p style="color: #D8511F;">Rejected</p>
                                </div>
                              </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="allocationColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: allocationColumns;"></tr>
                          </table>
                        </div>


                      </mat-expansion-panel>
                    </mat-accordion>
                  </div>



                </div>
              </div>

              <ng-template #noVersions>
                <div class="noVersions" style="padding-top: 30px;text-align: center;">
                  {{'ORDER_DASHBOARD.noStatus' | translate}}
                </div>
              </ng-template>
            </div>
          </div>
          <div class="statusTable" *ngIf="tabIndex == 1">
            <div class="tabs">
              <mat-grid-list cols="3">
                <mat-grid-tile [ngClass]="{tabSelected :tab == 0}" (click)="tab=0;changeTab();">
                  <!--[ngStyle]="{'background-color':tab == -1? '#2f3b91':'#ffffff', 'color':tab == -1? '#ffffff':'#2f3b91'}"-->
                  <div class="iconLabel">
                    <img [hidden]="tab == 0" src="assets/Assigned.svg" alt="">
                    <img *ngIf="tab == 0" src="assets/Assigned – White.svg" alt="">
                    <div class="statusLab">{{'ORDER_DASHBOARD.assigned' | translate}}</div>
                  </div>
                </mat-grid-tile>
                <mat-grid-tile [ngClass]="{tabSelected :tab == 1}" (click)="tab =1;changeTab();">
                  <div class="iconLabel">
                    <img [hidden]="tab == 1" src="assets/InTransit.svg" alt="">
                    <img *ngIf="tab == 1" src="assets/InTransit – White.svg" alt="">
                    <div class="statusLab">{{'ORDER_DASHBOARD.inTransit' | translate}}</div>
                  </div>
                </mat-grid-tile>
                <mat-grid-tile [ngClass]="{tabSelected :tab == 2}" (click)="tab =2;changeTab();">
                  <div class="iconLabel">
                    <img [hidden]="tab == 2" src="assets/Completed.svg" alt="">
                    <img *ngIf="tab == 2" src="assets/Completed – White.svg" alt="">
                    <div class="statusLab">{{'ORDER_DASHBOARD.completed' | translate}}</div>
                  </div>
                </mat-grid-tile>
              </mat-grid-list>
            </div>
            <div class="tableContent">
              <table mat-table *ngIf="shipmentStatusArray.length;else noShipments" [dataSource]="shipmentStatusArray">
                <ng-container matColumnDef="SIN">
                  <th mat-header-cell *matHeaderCellDef>{{'ORDER_DASHBOARD.shipments' | translate}}</th>
                  <td mat-cell *matCellDef="let element">{{element.SIN}}</td>
                </ng-container>
                <ng-container matColumnDef="shipper">
                  <th mat-header-cell *matHeaderCellDef>{{'ORDER_DASHBOARD.shipperName' | translate}}</th>
                  <td mat-cell *matCellDef="let element">{{element.shipper}}</td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="shipmentsColumns"></tr>
                <tr mat-row class="shipmentRow" (click)="openShipmentDetails(row)"
                  *matRowDef="let row; columns:shipmentsColumns;"></tr>
              </table>
              <ng-template #noShipments>
                <div class="no{{'ORDER_DASHBOARD.shipments' | translate}}"
                  style="padding-top: 30px; text-align: center;">
                  {{'ORDER_DASHBOARD.noShipFound' | translate}}
                </div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="showLoader" class="loader">
        <div class="load">
          <mat-spinner></mat-spinner>
        </div>
      </div>
      <ng-template #noOrders>
        <div class="noOrders" style="padding: 30px; text-align: center;">
          {{'ORDER_DASHBOARD.noOrder' | translate}}
        </div>
      </ng-template>
    </div>




  </div>
</div>
<ng-template #uploadDocs>


  <div class="uploadDialogMain">
    <div class="header">
      <div class="label">
        {{'ORDER_DASHBOARD.play_video_header' | translate}}
      </div>
      <div class="close">
        <span class="material-icons" (click)="uploadDocsRef.close()" style="cursor: pointer;">
          close
        </span>
      </div>
    </div>
    <div class="body">
      <div>
        <div style="
                    position: relative;
                    padding-bottom: 56.25%;
                    height: 0;
                    border-radius: 0;
                    box-shadow: 0 15px 40px rgba(63,58,79,.3);
                    overflow: hidden;
                    min-width:320px">
          <iframe [src]="video_URL" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;">
          </iframe>

        </div>
      </div>
    </div>
  </div>

</ng-template>
<ng-template #ChatBoxComponent>
  <div class="chatbox-main">
    <div class="header">
      Order Number - {{orderNumber}}
      <div class="close">
        <span class="material-icons" (click)="chatboxRef.close()" style="cursor: pointer;">
          close
        </span>
      </div>
    </div>
    <div #outerbody class="outer-body">
      <div class="body" *ngIf="!messageArray.length" style="margin-top: 106px;margin-left: 50px;">
        <div class="no-message">
          {{'ORDER_DASHBOARD.no_message' | translate}}
        </div>
      </div>
      <div class="body" *ngFor="let data of messageArray">
        <div class="left" *ngIf="data.typeOfUser === 'Carrier'">
          <div class="text-message">
            <img src="assets/carrier-icon.svg" alt="">
            <div class="message-value">
              <span>{{ data.message }}</span>
              <span style="color: blue; font-size: 10px;">{{data.sentDate}} {{data.sentTime}}</span>
            </div>
          </div>
        </div>
        <div class="right" *ngIf="data.typeOfUser === 'Shipper'">
          <div class="text-message">
            <div class="message-value">
              <span>{{data.message}}</span>
              <span style="font-size: 10px; margin-bottom: 3px; color: blue">{{data.sentDate}}
                {{data.sentTime}}</span>
            </div>
            <img src="assets/shipper-icon.svg" alt="">
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <input class="message-input" type="text" placeholder="Type a message" [(ngModel)]="textMessage"
        (keyup.enter)="sendMessage()">
      <img src="assets/sendActive.svg" *ngIf="textMessage.length" (click)="sendMessage()">
      <img src="assets/sendInactive.svg" *ngIf="!textMessage.length">
    </div>
  </div>

</ng-template>